module.exports = __webpack_public_path__ + "sq15-aa9d3e45.png";